import CookieUtils from '../cookie-utils';

export const GlobalBasketAnalytics = {
  init : () => {
    if(!window.jlData.basket) {
      window.jlData.basket = {};
      window.jlData.basket.product = [];
    }

    let basketCookie = CookieUtils.get('cached_basket');
    let subTotalCheck = basketCookie ? basketCookie.indexOf('subTotal') : null;

    if(basketCookie && subTotalCheck >= 0) {
      GlobalBasketAnalytics.formatBasketData(basketCookie);
    }
  },

  formatBasketData: data => {
    let products = data.split('^');
    if(products.length == 2) {
      products.pop();
      const subTotal = products.pop().split("=")[1];
      GlobalBasketAnalytics.setAnalyticsProductData([], subTotal);
    } else {
      products.pop(); // Removes the last part of the array which counts the length of the items and isn't needed.
      let subTotal = products.pop().split("=")[1];
      let analyticsProducts = [];

      if(products.length > 1) {
        for( let product of products ) {
          let parts = splitParts(product);
          analyticsProducts.push(structureAnalyticsObj(parts));
        }
      } else {
        let parts = splitParts(products[0]);
        analyticsProducts.push(structureAnalyticsObj(parts));
      }
      GlobalBasketAnalytics.setAnalyticsProductData(analyticsProducts, subTotal);
    }
  },

  setAnalyticsProductData : (products, subTotal) => {
    window.jlData.basket.product = products;
    window.jlData.basket.subTotal = subTotal;
  }
}

// Helper Functions
function splitParts(data) {
  return data && data.split("|");
}

function structureAnalyticsObj(parts) {
  let obj = {};

  if(parts.length > 6 & parts[6] !== "") {
    let servicesArray = []
    let servicesString = parts.pop();
    let services = servicesString.split("~");

    for( let service of services ) {
      let serviceParts = service.split("-");
      servicesArray.push({
        itemPrice : serviceParts[3],
        productId : serviceParts[1],
        qty: serviceParts[4],
        sku : serviceParts[2]
      });
    }

    obj = {
      itemPrice : parts[4],
      productId : parts[1],
      qty : parts[5],
      services : servicesArray,
      sku : parts[3],
    }

  } else {
    obj = {
      itemPrice : parts[4],
      productId : parts[1],
      qty : parts[5],
      services : [],
      sku : parts[3]
    }
  }
  return obj
}
